import React, { FC } from 'react';
import { observer } from 'mobx-react';
import Modal from '../shared/modal/modal';
import { ModalTexts, ModalTypes } from '../../constans/modal.constants';
import { useStore } from './../../store/store-provider';
import { MIXPANEL_EVENT_IDENTIFIERS } from '../../constans/mixpanel-contants';
import { getMixpanelService } from '../../utils/services/mixpanel-service-instance';

const LaunchPreviewModal: FC = () => {
  const { podiumInfoStore } = useStore();
  const { setIsShowLaunchPreviewModal, getPreviewLink } = podiumInfoStore;

  const closeActionHandler = () => {
    setIsShowLaunchPreviewModal(false);
  };

  const doneActionHandler = () => {
    const link = getPreviewLink() || '';
    window.open(link, '_blank');
    closeActionHandler();
    getMixpanelService().track(MIXPANEL_EVENT_IDENTIFIERS.LAUNCH_PREVIEW, null);
  };

  return (
    <Modal
      doneAction={doneActionHandler}
      cancelAction={closeActionHandler}
      modalType={ModalTypes.CONFIRMATION}
      bodyText={ModalTexts.LAUNCH_PREVIEW_MESSAGE}
      doneButtonText={ModalTexts.LAUNCH_PREVIEW_DONE_TEXT}
    />
  );
};

export default observer(LaunchPreviewModal);
